<template>
  <div class="main-menu-container">
    <div class="main-menu fixed bottom-0 md:bottom-4 flex justify-around w-full px-4 py-3 md:w-[32rem] text-white">
      <template v-for="(menu, index) in menus" :key="index">
        <router-link :to="menu.path" :id="menu.id" :class="['flex flex-col items-center text-xs p-2 rounded-2xl', {'text-[#67011b] bg-[rgba(255,255,255,0.5)]': isActive(menu.path)}]">
          <component :is="menu.icon" class="h-7 w-7 text-bold"></component>
          {{ menu.name }}
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import { HomeIcon, PresentationChartBarIcon, UserGroupIcon, CubeIcon, ListBulletIcon, CogIcon } from '@heroicons/vue/24/solid';

export default {
  name: 'MainMenu',
  components: {
    HomeIcon, PresentationChartBarIcon, UserGroupIcon, CubeIcon, ListBulletIcon, CogIcon
  },
  data() {
    return {
      menus: [
        { name: 'Home', path: '/home', id: 'url-home', icon: HomeIcon },
        { name: 'Customer', path: '/customer', id: 'url-customer', icon: UserGroupIcon },
        { name: 'Reminder', path: '/reminder', id: 'url-reminder', icon: ListBulletIcon },
        { name: 'Transaction', path: '/transactions', id: 'url-transaction', icon: PresentationChartBarIcon },
        { name: 'Product', path: '/product', id: 'url-product', icon: CubeIcon },
        { name: 'Setting', path: '/setting', id: 'url-setting', icon: CogIcon },
      ]
    }
  },
  methods: {
    isActive(path) {
      return this.$route.path.startsWith(path);
    }
  }
}
</script>

<style scope>
  .main-menu-container {
    display: flex;
    justify-content: center;
  }
  .main-menu {
    border-radius: 3rem;
    background-color:rgba(243, 128, 157, 0.7);
  }
</style>